
<script>
import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import AceEditor from '@src/components/ace-editor.vue'
import TicketView from '@src/components/ticket-view.vue'
import DocsView from '@src/components/docs-view.vue';

const JIRA_API_TOKEN = "XbfrYfnrDOW0fqYoJsJgBF25";

const EPIC_TAG = 'h1';
const STORY_TAG = 'h2';
const TASK_TAG = 'h3';

var _ = require('lodash');

export default {
  page: {
    title: 'Editor',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {DocsView, Layout, AceEditor, TicketView },
    data() {
        return {
            markdownPanel:true,
            ticketsPanel:true,
            docsPanel:true,
            // codePanel:false,
            epics: [],
            tokens: [],
            currentStory: undefined,
            tokenIndex: undefined,
            showGenAssets: false
        }
    },
    computed:{
        prettyEpics : function() {
            return JSON.stringify(this.epics, null, 2); // spacing level = 2
        },
        prettyTokenIndex : function() {
            return JSON.stringify(this.tokens[this.tokenIndex], null, 2); // spacing level = 2
        },
        markdown () {
            return this.$store.state.lineCommand.markdown;
        },
        ticketContent () {
            return this.$store.state.lineCommand.tickets;
        },
        docContent () {
            return this.$store.state.lineCommand.docs;
        },
        // codeContent () {
        //     return this.$store.state.lineCommand.code;
        // },
        ticketMarkdown () {
            return this.$store.state.lineCommand.ticketMarkdown;
        },
        docMarkdown () {
            return this.$store.state.lineCommand.docMarkdown;
        },
        // codeMarkdown () {
        //     return this.$store.state.lineCommand.codeMarkdown;
        // },
        markdownPanelClass(){
            return (this.markdownPanel) ? 'col': 'collapsed-col';
        },
        ticketsPanelClass(){
            return (this.ticketsPanel) ? 'col': 'collapsed-col';
        },
        docsPanelClass(){
            return (this.docsPanel) ? 'col': 'collapsed-col';
        },
        // codePanelClass(){
        //     return (this.codePanel) ? 'col': 'collapsed-col';
        // }
    },
    watch : {
        markdown: function(value){
            this.splitMarkdownToContent();
        },
        ticketContent: function(){
          this.splitMarkdownToContent();
        },
        docContent: function(value){
            this.splitMarkdownToContent();
        },
        // codeContent: function(value){
        //     this.splitMarkdownToContent();
        // },
    },
    mounted (){
        this.md = require('markdown-it')();
        this.splitMarkdownToContent();
    },
    methods: {
        genAssetsModal(data){
            console.log('genAssetsModal');
            this.showGenAssets = true;
        },
        togglePanel(panel){
          this[panel] = !this[panel];
        },
        createIssue(){
            let ticket = this.epics[0];

            let issue = {
                summary : ticket.title,
                issuetype: {
                    id: ticket.type
                },
                project: {
                    "key": "TEST"
                },
                description: {
                    type: "doc",
                    version: 1,
                    content: [
                        {
                            type: "paragraph",
                            content: [
                                {
                                    text: ticket.description,
                                    type: "text"
                                }
                            ]
                        }
                    ]
                }
            };

            var options = {
                method: 'POST',
                url: '/rest/api/3/issue',
                auth: { username: 'rob.rhyne@gmail.com', password: JIRA_API_TOKEN },
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: issue
            };

            axios(options).then(response => (console.log(response)))

        },
        reset () {
            this.content = 'reset content for Editor A'
        },
        parseTokens: function(tokens){
            let epic = {};
            let epics = [];
            // get epics
            let i = 0;
            for (i; i<tokens.length; i++) {
                let t = tokens[i];
                // current i is an epic
                if(t.type === 'heading_open' && t.tag === EPIC_TAG){
                    // this is the second epic,  set the end of the previous epic to the prior index
                    // (an epic and it's children end when the next one begins or the doc ends)
                    // we know the next token is the title, so take it now

                    if( epic.start >= 0 && epic.end === undefined ){
                        epic.end = i - 1;
                        epics.push(epic);
                    }

                    epic = {start: i};
                    epic.title = tokens[i+1].content;
                    epic.description = "";
                }
            }

            // There should always be an end epic to the current epic
            epic.end = i;
            epics.push(epic);

            this.epics = this.parseContent(epics, STORY_TAG);
        },
        parseWireframes: function(title, desc){
          if(title.indexOf('GUI') === -1) return false;
          let wires = "<div class='container'>";

          const tokens = ['TABLE', 'COL-6'];
          const html = [
              "<table class='table striped table-borderless'><tr><th>Column</th></tr></table>", // table
              "<div class='col-6'>col 6 content</div>"
          ];

          /// const lines = this.stripHtml(desc).split('\n');
          const words = this.stripHtml(desc).split(/(\s+)/);
          // console.log('words',words);

          for(let i=0;i < words.length; i++){
            const word = words[i];

            if(tokens.indexOf(word) != -1){
                // console.log('Found token', word);
                wires += html[i];
            }
          }

          wires += "</div>";
          return wires
        },
        stripHtml: function(html)
        {
            var tmp = document.createElement("DIV");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        },
        parseContent: function(parents, childTag){
            // if(childTag === TASK_TAG || childTag === undefined) console.log('parseContent', childTag, parents);
            // get epics
            let i = 0;
            for (i; i < parents.length; i++) {
                // for each parent, extract children
                // console.log(parents[i]);
                let j = parents[i].start;
                let children = [];
                let child = {};
                // loop over tokens bound by the parent's start and end token indexes
                // if(childTag === TASK_TAG) console.log('start and end index:',j, parents[i].end);
                for (j; j < parents[i].end; j++) {
                    const t = this.tokens[j];
                    // while child is still null, we are working on the parent
                    // if(childTag === TASK_TAG) console.log(j,childTag, 'child', child);

                    if(_.isEmpty(child)){
                        if (t.type === 'paragraph_open' && t.tag === "p") {
                            let description = "<p>" + this.tokens[j+1].content + "</p>\n";
                            // if(childTag === TASK_TAG) console.log('doing description for', parents[i]);

                            parents[i].description += description
                        }
                    }

                    // //parse the description into wireframes
                    // let wires = this.parseWireframes(parents[i].title, parents[i].description);
                    // if (wires !== false){
                    //     parents[i].wireframes = wires;
                    // }

                    // found a child
                    // if(childTag === TASK_TAG) console.log('compare',t.tag, childTag);
                    if (t.type === 'heading_open' && t.tag === childTag) {
                        // this is the next child,  set the end of the previous child to the prior index
                        if (child.start >= 0 && child.end === undefined) {
                            child.end = j - 1; // prior index
                            children.push(child);
                        }

                        // start the new child
                        child = {start: j};
                        child.title = this.tokens[j+1].content;
                        child.description = "";
                    }
                }

                // There should always be an end epic to the current epic
                child.end = j;
                children.push(child);

                let childname, nextChildTag;
                let noProcess = false;
                if(childTag === STORY_TAG){
                    childname = 'stories';
                    nextChildTag = TASK_TAG;
                    // console.log('STORIES', children, 'next tag',nextChildTag);
                }else if(childTag === TASK_TAG){
                    // console.log('TASKS', children);
                    childname = 'tasks';
                    nextChildTag = undefined;
                }else{
                    noProcess = true;
                }

                // parse the children items
                // console.log('nextChildTag', nextChildTag);
                let parsedChildren = [];
                // for(let p = 0; p < children.length; p++) {
                if(!noProcess){
                    parsedChildren = this.parseContent(children, nextChildTag);
                }
                parents[i][childname] = parsedChildren;

            }
            return parents;
        },
        parseMarkdownForTickets: function(md){
            this.epics = [];
            this.tokens = this.md.parse(md);
            this.parseTokens(this.tokens);
        },
        splitMarkdownToContent (){
            const vm = this;
            const mdArray = this.markdown.split("\n");

            let ticketMarkdown = [];
            let docMarkdown = [];
            let codeMarkdown = [];

            _.each(vm.ticketContent, function(item, index){
                if(item) ticketMarkdown.push(mdArray[index]);
            });
            const ticketMarkdownString = ticketMarkdown.join("\n");
            this.$store.commit('lineCommand/setTicketMarkdown', ticketMarkdownString );
            vm.parseMarkdownForTickets(ticketMarkdownString);

            _.each(vm.docContent, function(item, index){
                if(item) docMarkdown.push(mdArray[index]);
            });
            let mdc = docMarkdown.join("\n");
            mdc = this.md.render(mdc);
            this.$store.commit('lineCommand/setDocMarkdown', mdc);

            // _.each(vm.codeContent, function(item, index){
            //     if(item) codeMarkdown.push(mdArray[index]);
            // });
            // this.$store.commit('lineCommand/setCodeMarkdown',codeMarkdown.join("\n"));
        }
    }
}
</script>

<template>
  <Layout>

  <transition name="modal-slide-fade">
      <div v-if="showGenAssets">
              <div class="modal-mask">
                  <div class="modal-wrapper">
                      <div class="modal-dialog" role="document">
                          <div class="modal-content">
                              <div class="modal-header mt-4">
                                  <h5 class="modal-title">Generate Assets</h5>
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true" @click="showGenAssets = false">&times;</span>
                                  </button>
                              </div>
                              <div class="modal-body">
                                  <p>Todo: UI for generating tickets and/or documentation.</p>
                              </div>
                              <div class="modal-footer">
                                  <button type="button" class="btn btn-secondary" @click="showGenAssets = false">Close</button>
                                  <button type="button" class="btn btn-primary">Create</button>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
      </div>
  </transition>

    <div class="row  mt-4">
      <div class="col-10">
        <h4>Create Features</h4>
      </div>
      <div class="col-2 text-right">
        <button class="btn btn-primary" v-on:click="genAssetsModal" v-show="!showGenAssets">Generate Assets</button>
      </div>
    </div>

    <div class="row">

      <div :class="markdownPanelClass">
        <div class="row columnHeader">
          <div v-show="markdownPanel" class="col-9">
            <h5 class="p-0">
              <BaseIcon name="markdown" source="svg"></BaseIcon>
              <span>Markdown</span>
            </h5>
          </div>
          <div class="col-3 text-right">


              <!-- doc icon -->
              <div class="float-right">
                  <BaseIcon name="docsLine" source="svg"></BaseIcon>
              </div>

              <!-- ticket icon -->
              <div class="float-right mr-2">
                  <BaseIcon name="ticketLine" source="svg"></BaseIcon>
              </div>

              <div class="float-right mr-2">
                  <a v-show="markdownPanel" @click="togglePanel('markdownPanel')">
                      <BaseIcon name="toggleCol" source="svg" ></BaseIcon>
                  </a>
              </div>


          </div>
        </div>

        <AceEditor v-show="markdownPanel" editor-id="editor" :content="markdown"></AceEditor>

          <a v-show="!markdownPanel" @click="togglePanel('markdownPanel')">
              <BaseIcon name="markdown" source="svg"></BaseIcon>
          </a>

      </div>

      <div class="pl-0" :class="ticketsPanelClass">

        <div v-show="ticketsPanel" class="row columnHeader">
          <div class="col-11" >
            <h5 class="p-0">
                <BaseIcon name="ticket" source="svg"></BaseIcon>
              <span>Tickets</span>
            </h5>
          </div>
          <div class="col-1 text-right">
            <a v-show="ticketsPanel" @click="togglePanel('ticketsPanel')">
                <BaseIcon name="toggleCol" source="svg"></BaseIcon>
            </a>
          </div>
        </div>

    <transition name="slide-fade">
        <div v-show="ticketsPanel" style="background-color:white">

            <div v-show="this.markdown == ''" class="epic text-left p-3" >
                <h4 style="color:#A7A8BB">How To</h4>
                <div class="p-5" >
                    <h5 style="color:#A7A8BB">Create Tickets</h5>
                    <p>To create a ticket, type:</p>
                    <p># My Ticket Tile = for an epid</p>
                    <p>## My Ticket Tile = for a story</p>
                    <p>### My Ticket Tile = for a task</p>
                </div>

                <div class="p-5">
                    <h5 style="color:#A7A8BB">Describe Tickets</h5>
                    <p>Describe the ticket with lines of text and other markdown below the title as so:</p>
                    <p>## My Story</p>
                    <p>My story is described with normal text, lists and other markdown.</p>
                    <p>
                        * A list item
                        * A 2nd list item
                    </p>
                </div>
            </div>

            <div v-for="(e, eIndex) in epics" v-if="epics && epics[0].title" v-show="ticketsPanel"
                 :key="eIndex" class="epic col-12 p-2">
                <TicketView :ticket="e" type="epic"></TicketView>

                <div v-for="(s,sIndex) in e.stories" :key="sIndex" style="margin-left:20px;" class="story">
                    <TicketView :ticket="s" type="story"></TicketView>

                    <div v-for="(t, tIndex) in s.tasks" :key="tIndex" style="margin-left:20px;">
                        <TicketView :ticket="t" type="task"></TicketView>
                    </div>
                </div>
            </div>

        </div>
    </transition>


        <div v-show="!ticketsPanel">
          <a @click="togglePanel('ticketsPanel')" >
              <BaseIcon name="ticket" source="svg"></BaseIcon>
          </a>
        </div>

      </div>

      <div id="docsPanel" class="pl-0" :class="docsPanelClass">

        <div v-show="docsPanel" class="row columnHeader">
          <div class="col-11" >
            <h5>
                <BaseIcon name="docs" source="svg"></BaseIcon>
              <span>Documentation</span>
            </h5>
          </div>
          <div class="col-1 text-right">
            <a v-show="docsPanel" @click="togglePanel('docsPanel')">
              <BaseIcon source="svg" name="toggleCol"></BaseIcon>
            </a>
          </div>
        </div>

        <div v-show="!docsPanel" class="text-right">
          <a @click="togglePanel('docsPanel')" >
              <BaseIcon source="svg" name="docs"></BaseIcon>
          </a>
        </div>

        <div v-show="docsPanel" class="col-12">
          <DocsView :docs="docMarkdown"></DocsView>
        </div>

      </div>

      <!--<div :class="codePanelClass">-->
        <!--<div class="row">-->
          <!--<div class="col-10" v-show="codePanel">-->
            <!--<h4>Code</h4>-->
          <!--</div>-->
          <!--<div class="col-1 text-right">-->
            <!--<a v-on:click="togglePanel('codePanel')" v-show="codePanel">-->
              <!--<BaseIcon name="eye-slash" />-->
            <!--</a>-->
            <!--<a v-on:click="togglePanel('codePanel')" v-show="!codePanel">-->
              <!--C-->
            <!--</a>-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="row" v-show="codePanel">-->
          <!--{{codeMarkdown}}-->
        <!--</div>-->
      <!--</div>-->

    </div>



  </Layout>
</template>

<style>
  .collapsed-col{
    width:30px;
    background-color: #F2F6FB;
    text-align:center;
    margin-right: 15px;
  }



  .columnHeader h5 svg{
    margin-top:-3px;
  }
  .columnHeader h5 span{
    margin-left:8px;
  }

  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
      transition: all 0.6s ease-in-out;
  }
  .slide-fade-leave-active {
      transition: all 0.6s ease-in-out;
  }
  .slide-fade-enter, .slide-fade-leave-to
      /* .slide-fade-leave-active below version 2.1.8 */ {
      transform: translateX(10px);
      opacity: 0;
  }

  .modal-slide-fade-enter-active {
      transition: all 0.6s ease-in-out;
  }



  .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
  }

  .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
  }


</style>
